<template>
  <div class="trending-articles">
    <div class="container">
      <h2 class="heading">TOP TRENDING ARTICLES</h2>

      <div class="articles">
        <div class="row" v-if="loading">
          <div class="col-md-4 article" v-for="(blog, n) in 6" :key="n">
            <ArticleCardSkeleton :index="n" />
          </div>
        </div>
        <div class="row" v-else>
          <div class="col-md-4 article" v-for="(blog, n) in blogs" :key="n">
            <ArticleCard
              :article="blog"
              :bookMarks="bookMarks"
              :follwedBloggers="follwedBloggers"
              :index="n"
              v-if="n < 6"
              @bookMarkBlog="bookMarkBlog"
              @followBlogger="followBlogger"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArticleCard from "@/components/other-pages/Blogs/ArticleCard";
import ArticleCardSkeleton from "@/components/other-pages/Blogs/ArticleCardSkeleton";
export default {
  name: "TrendingArticles",
  props: ["loading", "blogs", "bookMarks", "follwedBloggers"],
  components: {
    ArticleCard,
    ArticleCardSkeleton
  },
  methods: {
    bookMarkBlog(data) {
      this.$emit("bookMarkBlog", data);
    },
    followBlogger(data) {
      this.$emit("followBlogger", data);
    }
  }
};
</script>

<style lang="scss" scoped>
.trending-articles {
  padding-top: 33px;
  padding-bottom: 40px;
  .heading {
    margin-left: 12px;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    color: #474d52;
    margin-bottom: 4px;
  }
  .articles {
    .article {
      display: flex;
      justify-content: stretch;
      align-items: stretch;
      margin-bottom: 20px;
    }
  }
}
</style>
